import React, {Component} from 'react';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";

interface containerProps {
    isDropdownOpen: boolean
    toggle: () => void

    chartRef: any
    title: string
    subtitle: string
}

interface containerState {

}
class ExportChart extends Component<containerProps, containerState> {

    exportChart (type: string) {
        const chart = this.props.chartRef.current.chart;
        console.log(type);
        switch (type) {
            case 'print':
                chart.print();
                break;
            case 'png':
                chart.exportChart();
                break;
            default:
                chart.exportChart({
                    type: type
                });
        }
    }

    render() {
        return (
            <Dropdown direction="left" className='export-options-dropdown' isOpen={this.props.isDropdownOpen} toggle={this.props.toggle}>
                <DropdownToggle
                    tag="i"
                    data-toggle="dropdown"
                    aria-expanded={this.props.isDropdownOpen}
                    className="fas fa-fw fa-cloud-download-alt fa-lg"
                >
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem onClick={() => this.exportChart('print')}>Print chart</DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem onClick={() => this.exportChart('png')}>Download PNG image</DropdownItem>
                    <DropdownItem onClick={() => this.exportChart('image/jpeg')}>Download JPEG image</DropdownItem>
                    <DropdownItem onClick={() => this.exportChart('application/pdf')}>Download PDF image</DropdownItem>
                    <DropdownItem onClick={() => this.exportChart('image/svg+xml')}>Download SVG vector image</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    }
}

export default ExportChart;